import gql from 'graphql-tag';

export default gql`
fragment ShippingMethodAllFragment on ShippingMethod {
    id
    code
    name
    is_active
    sort
    price_ranges {
        from
        price
    }
    discount_price
    max_weight
    description
    short_description
    delivery_time
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/ShippingMethodAllFragment.ts